import axios from 'axios';

const api = axios.create({ baseURL: '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Avoid redirect loops on 401.
let redirecting = false;

api.interceptors.response.use(
  res => res,
  err => {
    const status = err.response?.status;
    if (status === 401 && !redirecting) {
      redirecting = true;
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
